// extracted by mini-css-extract-plugin
export var askAiIcon = "_m6-j";
export var category = "_m6-9";
export var categoryHeader = "_m6-e";
export var container = "_m6-0";
export var group = "_m6-a";
export var groupItems = "_m6-f";
export var groupSeparator = "_m6-k";
export var loading = "_m6-1";
export var noResults = "_m6-3";
export var placeholder = "_m6-2";
export var resultContent = "_m6-5";
export var resultIcon = "_m6-c";
export var resultItem = "_m6-g";
export var resultMeta = "_m6-8";
export var resultSubtitle = "_m6-7";
export var resultSuffix = "_m6-i";
export var resultTitle = "_m6-6";
export var resultsList = "_m6-4";
export var searchGroup = "_m6-d";
export var selected = "_m6-h";
export var subgroup = "_m6-b";